import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import LiveKaraoke from './components/LiveKaraoke';
import HoursLocation from './components/HoursLocation';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <LiveKaraoke />
      <Menu />
      <HoursLocation />
      <Contact />
      <Footer />
    </div>
  );
}
